import { faPeopleGroup, faUserGroup, faUser, faUsersRectangle } from "@fortawesome/free-solid-svg-icons"

export const category = [
 {
    value : 'family',
    name: 'Family',
    icon: faPeopleGroup
 },
 {
    value : 'friends',
    name: 'Friends',
    icon: faUsersRectangle
 },
 {
    value : 'couple',
    name: 'Couple',
    icon: faUserGroup
 },
 {
    value : 'single',
    name: 'Single',
    icon: faUser
 },
]